import { forwardRef, ReactNode } from 'react';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants } from '@arrived/common';

const StyledIconContainer = styled.div`
  &.icon-container {
    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

interface SocialShareIconProps {
  icon: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const SocialShareIcon = forwardRef<HTMLDivElement, SocialShareIconProps>(
  ({ icon, className, ...additionalProps }: SocialShareIconProps, ref) => {
    return (
      <StyledIconContainer ref={ref} className={clsx('icon-container', className)} {...additionalProps}>
        {icon}
      </StyledIconContainer>
    );
  }
);
